import { render, staticRenderFns } from "./CommingSoon.vue?vue&type=template&id=497a1f96&scoped=true&"
import script from "./CommingSoon.vue?vue&type=script&lang=js&"
export * from "./CommingSoon.vue?vue&type=script&lang=js&"
import style0 from "./CommingSoon.vue?vue&type=style&index=0&id=497a1f96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497a1f96",
  null
  
)

export default component.exports